import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../../tas';

export default class AuthenticatedCareerPathwaysTasProgramsIndexRoute extends Route {
  model(): ModelFrom<TasRoute> {
    return this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>;
  }
}
